import { useAuth } from "@airborne/react-admin";
import React from "react";
import { useOwnerCodeChangeListener } from "../../Helper/useOwnerCodeChangeListener";
import { useAppDataProvider } from "../../dataprovider";
import { Button, FormControl, MenuItem, Select } from "@material-ui/core";
import { useNotify } from "react-admin";
import { FlightTakeoffRounded, FlightLandRounded } from "@material-ui/icons";

export const OwnerSelection = () => {
  const { user, tokens } = useAuth();
  const { isConnected } = useOwnerCodeChangeListener(tokens?.accessToken || "");
  const dataProvider = useAppDataProvider();
  const notify = useNotify();
  const [selectedOwnerCode, setSelectedOwnerCode] = React.useState<any>(user?.ownerCode);
  const [ownerCodeList, setOwnerCodeList] = React.useState<any>([]);

  React.useEffect(() => {
    const channel = new BroadcastChannel("reloadTabs");
    channel.addEventListener("message", event => {
      if (event.data === "reload") {
        window.location.reload();
      }
    });
    return () => channel.close();
  }, []);

  React.useEffect(() => {
    GetOwnerCodeList();
  }, []);

  const GetOwnerCodeList = () => {
    dataProvider
      .getList("customers", {
        pagination: { page: 1, perPage: 10 },
        sort: { field: "id", order: "ASC" },
        filter: { relatedCustomerCode__eq: user?.relatedCustomerCode },
      })
      .then(response => {
        const ownerCodes = [...new Set(response?.data?.map(item => item.ownerCode))];
        setOwnerCodeList(ownerCodes);
      });
  };

  const UpdateOwnerCode = ownerCode => {
    dataProvider
      .putCustomerUserByRegisterId(ownerCode)
      .then(response => {
        setSelectedOwnerCode(ownerCode);
        notify(`Owner Updated`, "info");
        if (!isConnected) {
          const fallbackChannel = new BroadcastChannel("reloadTabs");
          setTimeout(() => {
            fallbackChannel.postMessage("reload");
            fallbackChannel.close();
          }, 500);
        }
      })
      .catch(error => {
        notify(`${error?.message}`, "error");
      });
  };

  return ownerCodeList?.length > 1 ? (
    <FormControl variant="outlined">
      <Select
        value={selectedOwnerCode}
        style={{ width: 200, height: 40 }}
        onChange={e => UpdateOwnerCode(e.target.value)}
      >
        {ownerCodeList.map((item, index) => (
          <MenuItem key={index} value={item}>
            <Button
              startIcon={selectedOwnerCode === item ? <FlightTakeoffRounded /> : <FlightLandRounded />}
              aria-haspopup={false}
              color="inherit"
            >
              {item}
            </Button>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  ) : (
    <></>
  );
};

export default OwnerSelection;
